export const rules = [{
        id: 1,
        title: "This category has 10 questions.",
    },
    {
        id: 2,
        title: "Each question has multiple choices.",
    },
    {
        id: 3,
        title: "Each question has one correct answer.",
    },
    {
        id: 4,
        title: "Each correct answer earns 10 points.",
    },
    {
        id: 5,
        title: "No questions can be skipped.",
    },
    {
        id: 6,
        title: "To go to next question, click on Next",
    },
    {
        id: 7,
        title: "To quite the game, click on Quit Now",
    },
];